// extracted by mini-css-extract-plugin
export default {"modalOverlay":"gH-z","modalContent":"hH-z","header":"iH-z","close":"jH-z"};